import { useEffect } from 'react';

export function useScrollTop(
  dep: number | string | boolean,
  smoothBehavior?: boolean
) {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: smoothBehavior ? 'smooth' : 'auto'
    });
  }, [dep, smoothBehavior]);
}
